import React from 'react';
import {useField} from 'formik';
import {t} from 'ttag';
import * as Title from '../../../../../title/title.jsx';
import {Input} from '../../../../../form/form.jsx';

const Label = () => {
  const [field, , helpers] = useField('label');

  const {setValue} = helpers;

  return (
    <>
      <Title.H2>{t`Connection name`}</Title.H2>

      <Input
        {...field}
        placeholder={t`Connection name`}
        onChange={setValue}
      />
    </>
  );
};

export default Label;
